export default __webpack_public_path__ + "static/media/ic_guatemala.5a0eada1.svg";